import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type QualityControlTrigger from "./QualityControlTrigger";

@Model()
class QualityControlPredictor extends ApplicationRecord {
  static jsonapiType = "quality_control_predictors";

  @Attr() approveThreshold: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() enabled: boolean;

  @Attr() medium: string;

  @BelongsTo() qualityControlTrigger: QualityControlTrigger;

  @Attr() qualityControlTriggerId: number;

  @Attr() rejectThreshold: number;

  @Attr({ persist: false }) updatedAt: string;
}

export default QualityControlPredictor;
